import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { FeatureToggles, IFBFeatureTogglesHTTPResponse } from '@app/models/feature-toggles';

@Injectable({
  providedIn: 'root'
})
export class FeatureTogglesResource {
  constructor(private http: HttpClient) {}

  private get url(): string {
    return `https://features.${environment.SERVICES_BASE}/api/features`;
  }

  public get(): Observable<FeatureToggles[]> {
    return this.http.get<IFBFeatureTogglesHTTPResponse>(this.url).pipe(
      map(response => {
        return response.features.map(feature => {
          return {
            key: feature.key,
            active: true,
            name: feature.key,
            description: feature.key
          };
        });
      })
    );
  }
}
